import { usePage } from '@inertiajs/react'
import { useEffect, useRef } from 'react'

import { useToast } from '@/hooks/use-toast'

/**
 * Surfaces Rails flash notice/alert as toasts after Inertia visits.
 * Must render under the Inertia App tree (see RootLayout).
 */
export function FlashToasts() {
  const { flash } = usePage().props
  const { toast } = useToast()
  const lastKey = useRef<string | null>(null)

  useEffect(() => {
    const notice = flash?.notice?.trim() || null
    const alert = flash?.alert?.trim() || null
    if (!notice && !alert) return

    const key = `${notice ?? ''}|${alert ?? ''}`
    if (lastKey.current === key) return
    lastKey.current = key

    if (notice) {
      toast({ description: notice, variant: 'success' })
    }
    if (alert) {
      toast({ description: alert, variant: 'destructive' })
    }
  }, [flash?.notice, flash?.alert, toast])

  return null
}
